import jQuery from "jquery";
import '../plugins/stickyScrollBlock';

// initialize fixed blocks on scroll
export default function stickyScrollBlock(){
  ResponsiveHelper.addRange({
		'1024..': {
			on: function() {
				jQuery('.add-nav').stickyScrollBlock({
					setBoxHeight: true,
					activeClass: 'fixed-position',
					positionType: 'fixed',
					extraTop: function() {
						var totalHeight = 0;
						jQuery('.header').each(function() {
							totalHeight += jQuery(this).outerHeight();
						});
						return totalHeight;
					}
				});
			},
			off: function() {
				jQuery('.add-nav').stickyScrollBlock('destroy');
			}
		}
	});

}
  